import {SortOptionsValues} from "../types/SortOptionsValues";

export const transformStringValueToSortOption = (sortValue?: string | null) => {
    switch (sortValue) {
        case "-floor":
            return SortOptionsValues.HIGHEST_FLOOR;
        case "floor":
        case "+floor":
            return SortOptionsValues.LOWEST_FLOOR;
        case "-price":
            return SortOptionsValues.HIGHEST_PRICE;
        case "price":
        case "+price":
            return SortOptionsValues.LOWEST_PRICE;
        case "-rooms":
            return SortOptionsValues.HIGHEST_ROOMS_NUMBER;
        case "rooms":
        case "+rooms":
            return SortOptionsValues.LOWEST_ROOMS_NUMBER;
        default:
            return SortOptionsValues.NOT_SELECTED;
    }
};
import {SortOptionsValues} from "../types/SortOptionsValues";

export const transformStringValueToSortOption = (sortValue?: string | null) => {
    switch (sortValue) {
        case "-floor":
            return SortOptionsValues.HIGHEST_FLOOR;
        case "floor":
        case "+floor":
            return SortOptionsValues.LOWEST_FLOOR;
        case "-price":
            return SortOptionsValues.HIGHEST_PRICE;
        case "price":
        case "+price":
            return SortOptionsValues.LOWEST_PRICE;
        case "-rooms":
            return SortOptionsValues.HIGHEST_ROOMS_NUMBER;
        case "rooms":
        case "+rooms":
            return SortOptionsValues.LOWEST_ROOMS_NUMBER;
        default:
            return SortOptionsValues.NOT_SELECTED;
    }
};
